import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { merchantInfoService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type MCCFieldValuesProps = {
	mccCode: string;
	merchantDescription: string;
	mccAliasId: string;
};

type MCCFieldMutationProps = {
	id: number;
	values: MCCFieldValuesProps;
	onSuccessHandler?: Function;
};

const useMCCFieldMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id, values }: MCCFieldMutationProps) => {
			return merchantInfoService.editMccField(
				id,
				values.mccCode,
				values.merchantDescription,
				values.mccAliasId,
			);
		},
		{
			onSuccess(data, { onSuccessHandler }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Field MCC code description has been updated successfully",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useMCCFieldMutation;
